// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5606":"b2ab389b","5762":"6fa5b0e5"}[chunkId] + ".chunk.css";
};